// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared page heading (accent eyebrow + serif title). Used across pages that
   sit under an AppBar control row, giving Wirder a single consistent header
   pattern. (.eyebrow / .eyebrow--accent live in tokens.css.) */
.pagehead {
  padding: 2px var(--pad) 16px;
}
.pagehead__title {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 1.05;
  margin-top: 3px;
}
.pagehead__sub {
  color: var(--palette-text-muted);
  font-size: 1rem;
  line-height: 1.4;
  margin-top: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/components/pageHeading.css"],"names":[],"mappings":"AAAA;;+DAE+D;AAC/D;EACE,4BAA4B;AAC9B;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["/* Shared page heading (accent eyebrow + serif title). Used across pages that\n   sit under an AppBar control row, giving Wirder a single consistent header\n   pattern. (.eyebrow / .eyebrow--accent live in tokens.css.) */\n.pagehead {\n  padding: 2px var(--pad) 16px;\n}\n.pagehead__title {\n  font-family: var(--font-display);\n  font-weight: 600;\n  font-size: 1.6rem;\n  line-height: 1.05;\n  margin-top: 3px;\n}\n.pagehead__sub {\n  color: var(--palette-text-muted);\n  font-size: 1rem;\n  line-height: 1.4;\n  margin-top: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
